<template>
  <article>
    <div class="mb-6 sm:mb-8 lg:mb-10">
      <work-header>
        <h3 class="inline-block">{{ subtitle }}</h3>
        <h2 class="inline-block">{{ termTitle }}</h2>
      </work-header>
      <h4>Terminal parameters</h4>
      <ul class="table">
        <li class="table-row">
          <span class="table-cell text-right w-20 sm:w-32">Project:&nbsp;</span>
          <span class="table-cell">{{ title }}</span>
        </li>
        <li v-if="types && types.length" class="table-row">
          <span class="table-cell text-right w-20 sm:w-32">Type:&nbsp;</span>
          <span class="table-cell">
            <span v-for="(type, i) in types" :key="type.id">
              {{ type.text
              }}<template v-if="i !== types.length - 1"
                >,</template
              >
            </span>
          </span>
        </li>
        <li v-if="year" class="table-row">
          <span class="table-cell text-right w-20 sm:w-32"
            >Year completed:&nbsp;</span
          >
          <span class="table-cell">{{ year }}</span>
        </li>
        <li v-if="tags && tags.length" class="table-row">
          <span class="table-cell text-right w-20 sm:w-32"
            >Disciplines:&nbsp;</span
          >
          <span class="table-cell">
            <work-tags :tags="tags" />
          </span>
        </li>
      </ul>
      <div v-if="summary" class="flex flex-no-wrap">
        <h4 class="flex-initial flex-shrink-0 text-right w-20 sm:w-32">
          Summary:&nbsp;
        </h4>
        <rich-text :text="summary" class="flex-auto max-w-3xl" />
      </div>
    </div>
    <gallery :slides="media" />
  </article>
</template>

<script>
import slugify from 'slugify'
import WorkHeader from '@/app/components/work/WorkHeader.vue'
import WorkTags from '@/app/components/work/WorkTags.vue'
import RichText from '@/app/components/RichText.vue'
import Gallery from '@/app/components/Gallery.vue'

export default {
  name: 'WorkProject',

  components: {
    WorkHeader,
    WorkTags,
    RichText,
    Gallery
  },

  props: {
    subtitle: {
      default: 'case studies',
      type: String
    },

    title: {
      default: '',
      type: String
    },

    types: {
      default: () => [],
      type: Array
    },

    year: {
      default: null,
      type: String
    },

    tags: {
      default: () => [],
      type: Array
    },

    summary: {
      default: null,
      type: String
    },

    media: {
      default: () => [],
      type: Array
    }
  },

  computed: {
    termTitle() {
      return slugify(this.title, { replacement: '_' })
    }
  }
}
</script>

<style scoped>
h3::after {
  content: '\005C'; /* backslash */
  display: inline;
}
</style>
